import script from "./TheTopBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheTopBar.vue?vue&type=script&lang=ts&setup=true"

import "./TheTopBar.vue?vue&type=style&index=0&id=5ff6b102&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff6b102"]])

export default __exports__